import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { BlueElement, register as blueRegister, nothing, ifDefined } from '@onviobr/element';
import { isContainerKey } from '@onviobr/toolbox-document-services/dist/esm5/models';
import { Subscription } from 'rxjs';
import { DiContainer } from '@onviobr/toolbox-document-services/dist/esm5';
import { cookie, deferred } from '@onviobr/services/utils';
import { styles } from './dms-viewer.css';
import { PdfTronElement, defaultOptions, EventType, AnnotationAction, AlertLocation, AlertType } from './dms-viewer-interface';
import { isWebViewerClientSupported } from './supported-types';
import { getLanguage } from './user-lang-to-pdftron-lang';
import { configureWebViewer, resetViewerOptions, configureDownloadButton, configureFilterModal, downloadDocument, configurePrintDialog, addClosableAlert, downloadDocumentFromViewer, exportAnnotations, checkIfWatermarkIsSet, handleKeyDown } from './dms-viewer-configurator';
import { AnnotationCreate, AnnotationDelete, AnnotationEdit, DocumentChanges, DocumentUpdate } from './models/annotation-modification';
import { AnnotationEditController } from './annotation-editor/annotation-edit-controller';
import { defaultDebounceIntervalMilliseconds, footerStyles, navigationButtonStyles, WebSocketEventType } from './dms-viewer-configuration-constants';
import { webSocketServiceConstructor } from './websocket/websocket.service';
import { documentUpdateEventFieldRenameMap } from './models/field-rename-map';
import { BLANK_ANNOTATIONS_XFDF } from './annotation-editor/get-annotation-ids-from-xfdf';
import { dmsViewerFieldEditTrackerConstructor } from './dms-viewer-field-edit-tracker';
import { restoreLineBreaks, storeLineBreaksInfo } from './free-text-formatter';
var DmsViewer = /*#__PURE__*/function (_BlueElement) {
  function DmsViewer() {
    var _this;
    _classCallCheck(this, DmsViewer);
    _this = _callSuper(this, DmsViewer);
    _this.container = void 0;
    _this.document = void 0;
    _this.documentUrl = void 0;
    _this.documentSiblings = void 0;
    _this.pageDataURL = void 0;
    _this.options = defaultOptions;
    _this.toolbarButtons = [];
    _this.hasPreviousDocument = false;
    _this.hasNextDocument = false;
    _this.userDisplayAs = void 0;
    _this.userContactId = void 0;
    _this.customStylesPath = void 0;
    _this.pdfDataURL = void 0;
    _this.loadSavedAnnotations = false;
    _this.subscribeForNotifications = false;
    _this.editAnnotations = false;
    _this.canPreviewDocument = false;
    _this.showPrintButton = false;
    _this.showWatermarkModal = false;
    _this.watermarkSettings = void 0;
    _this.showDownloadModal = false;
    _this.hideDocumentPreview = false;
    _this.documentIsLoading = false;
    _this.closeCallback = void 0;
    _this.finalizationFunctionContainer = void 0;
    _this.documentIsDownloading = false;
    _this.toolbarActions = void 0;
    _this.customSelectMultiple = void 0;
    _this.pageNo = void 0;
    _this.finishScanClicked = void 0;
    _this.fetchLatestPageData = void 0;
    _this.isPageInserted = void 0;
    _this.isCombinePDFBrokenPdfMessage = void 0;
    _this.webViewer = void 0;
    _this.containerSubscription = new Subscription();
    _this.siblings = [];
    _this.lastLoadedDocumentId = void 0;
    _this.lastLoadedDocumentName = void 0;
    _this.lastLoadedContainerId = void 0;
    _this.currentDocument = void 0;
    _this.isPdfDocument = false;
    _this.passwordEntered = false;
    _this.passwordPromise = void 0;
    _this.treeStore = void 0;
    _this.viewerLoaded = deferred();
    _this.suspendAnnotationChangeEvent = false;
    _this.suspendLayoutChangeEvent = false;
    _this.annotationsService = void 0;
    _this.documentService = void 0;
    _this.annotationEditor = void 0;
    _this.annotationEditState = void 0;
    _this.fieldEditTracker = void 0;
    _this.navigationButtons = void 0;
    _this.contentAreaNavigationButtons = void 0;
    _this.websocketService = void 0;
    _this.viewport = void 0;
    _this.documentBlob = void 0;
    _this.bmCoreFileViewerOptions = {};
    _this.isDocumentValid = true;
    _this.passwordModalIsVisible = false;
    _this.newDocumentName = void 0;
    _this.webSocketSubscriberId = DmsViewer.generateRandomSocketClientId();
    _this.annotationChangedHandler = void 0;
    _this.documentChangedHandler = void 0;
    _this.formInputsChangedHandler = void 0;
    _this.treeStore = DiContainer.instance.treeStore;
    _this.annotationsService = DiContainer.instance.annotationsServiceV2;
    _this.documentService = DiContainer.instance.documentService;
    return _this;
  }
  _inherits(DmsViewer, _BlueElement);
  return _createClass(DmsViewer, [{
    key: "isFileTypeSupported",
    get: function get() {
      return !this.hasAttribute('not-supported');
    },
    set: function set(isFileTypeSupportedByViewer) {
      if (isFileTypeSupportedByViewer) {
        this.removeAttribute('not-supported');
      } else {
        this.setAttribute('not-supported', '');
      }
    }
  }, {
    key: "currentDocumentName",
    get: function get() {
      var _this$currentDocument;
      return (_this$currentDocument = this.currentDocument) === null || _this$currentDocument === void 0 ? void 0 : _this$currentDocument.name;
    }
  }, {
    key: "updated",
    value: function updated(changes) {
      if (changes.has('container')) {
        var _this$container;
        this.lastLoadedContainerId = (_this$container = this.container) === null || _this$container === void 0 ? void 0 : _this$container.id;
        this.watchContainer();
        this.collapseDropDowns();
      }
      if (this.document && changes.has('options')) {
        var prevOptions = changes.get('options');
        void this.configureViewerAppearance(prevOptions);
        void this.configureFields();
      }
      if (changes.has('documentSiblings')) {
        if (this.documentSiblings) {
          this.unsubscribeContainerChanges();
          this.siblings = this.documentSiblings;
        }
      }
      if (this.document && (changes.has('document') || changes.has('container')) && (this.lastLoadedDocumentId !== this.document.id || this.lastLoadedDocumentName !== this.document.name)) {
        this.isDocumentValid = true;
        this.lastLoadedDocumentId = this.document.id;
        this.lastLoadedDocumentName = this.document.name;
        if (this.navigationButtons) {
          this.updateNavigationButtons(this.navigationButtons[0], this.navigationButtons[1]);
          this.toggleNavigationButtonsOpacity(false);
        }
        void this.resetPreviewModal();
        void this.loadDocument();
      }
      if (changes.has('documentUrl')) {
        void this.loadDocumentWithUrl();
      }
      if (changes.has('userDisplayAs')) {
        void this.setCurrentUser();
      }
      if (changes.has('pageDataURL') && this.pageDataURL) {
        if (!this.isPageInserted && this.document || this.documentUrl && this.pageNo) {
          void this.insertPageAtCertainIndexIntoDocument(this.pageDataURL);
          return;
        }
        if (!this.document) void this.insertPageIntoDocument(this.pageDataURL);
      }
      if (changes.has('pdfDataURL') && this.pdfDataURL) {
        void this.insertMultiplePagesIntoDocument(this.pdfDataURL);
      }
      if (changes.has('showDownloadModal') && !changes.get('showDownloadModal') && this.showDownloadModal && !this.isDocumentValid) {
        this.closeDownloadModalHandler();
        void downloadDocument(this.document, this.container);
      }
      if (changes.has('finishScanClicked') && this.finishScanClicked) {
        void this.emitBlob();
        void this.emitAnnotations();
      }
      if (changes.has('fetchLatestPageData') && this.fetchLatestPageData) {
        void this.emitLatestPageData();
      }
    }
  }, {
    key: "firstUpdated",
    value: function () {
      var _firstUpdated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$options$disable;
        var locale;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getLanguage();
            case 2:
              locale = _context.sent;
              this.bmCoreFileViewerOptions = _objectSpread(_objectSpread({}, this.bmCoreFileViewerOptions), {}, {
                disableDefaultElements: true,
                locale: locale,
                readonly: this.options.readonly,
                editable: this.options.editable,
                disabledElements: (_this$options$disable = this.options.disabledElements) !== null && _this$options$disable !== void 0 ? _this$options$disable : this.bmCoreFileViewerOptions.disabledElements
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function firstUpdated() {
        return _firstUpdated.apply(this, arguments);
      }
      return firstUpdated;
    }()
  }, {
    key: "closeClick",
    value: function closeClick() {
      this.closeCallback();
    }
  }, {
    key: "keyDown",
    value: function keyDown(e) {
      handleKeyDown(e, this.closeCallback);
    }
  }, {
    key: "watermarkModalOpenedHandler",
    value: function watermarkModalOpenedHandler() {
      this.showWatermarkModal = true;
    }
  }, {
    key: "watermarkModalClosedHandler",
    value: function watermarkModalClosedHandler() {
      this.showWatermarkModal = false;
    }
  }, {
    key: "watermarkChangedHandler",
    value: function watermarkChangedHandler(event) {
      this.watermarkSettings = _objectSpread({}, event.detail.options);
      void this.webViewer.Core.documentViewer.setWatermark(event.detail.options);
      var desiredWidth = 283;
      var maxHeight = 418;
      var pageNumber = 1;
      var rotation = this.webViewer.Core.documentViewer.getCompleteRotation(pageNumber);
      var width = this.webViewer.Core.documentViewer.getPageWidth(pageNumber);
      var height = this.webViewer.Core.documentViewer.getPageHeight(pageNumber);
      var pageWidth = rotation % 2 === 1 ? height : width;
      var pageHeight = rotation % 2 === 1 ? width : height;
      var zoom = desiredWidth * pageHeight / pageWidth > maxHeight ? maxHeight / pageHeight : desiredWidth / pageWidth;
      this.webViewer.Core.documentViewer.getDocument().loadCanvas({
        pageNumber: pageNumber,
        zoom: zoom,
        drawComplete: function drawComplete(canvas) {
          event.detail.canvasContainer.innerHTML = '';
          event.detail.canvasContainer.appendChild(canvas);
        }
      });
    }
  }, {
    key: "downloadDocumentHandler",
    value: function () {
      var _downloadDocumentHandler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        var promiseResult, password;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.documentIsDownloading = true;
              _context2.next = 3;
              return this.passwordPromise;
            case 3:
              promiseResult = _context2.sent;
              password = promiseResult ? String(promiseResult) : '';
              _context2.next = 7;
              return downloadDocumentFromViewer({
                webViewer: this.webViewer,
                key: this.document,
                container: this.container,
                documentMimeType: this.currentDocument.mimeType,
                includeAnnotations: event.detail.includeAnnotations,
                downloadAsPdf: event.detail.downloadAsPdf,
                password: password,
                newDocumentName: this.newDocumentName
              });
            case 7:
              this.documentIsDownloading = false;
              this.closeDownloadModalHandler();
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function downloadDocumentHandler(_x) {
        return _downloadDocumentHandler.apply(this, arguments);
      }
      return downloadDocumentHandler;
    }()
  }, {
    key: "closeDownloadModalHandler",
    value: function closeDownloadModalHandler() {
      var _this$webViewer;
      this.showDownloadModal = false;
      this.dispatchEvent(new CustomEvent(EventType.DownloadModalClosed));
      void ((_this$webViewer = this.webViewer) === null || _this$webViewer === void 0 ? void 0 : _this$webViewer.Core.documentViewer.setWatermark({}));
      this.watermarkSettings = null;
      this.focusViewer();
    }
  }, {
    key: "bmCoreFileViewerOptionsReady",
    value: function bmCoreFileViewerOptionsReady() {
      return !!this.bmCoreFileViewerOptions.locale;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$currentDocument2;
      return this.html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t<div class=\"dms-viewer ", "\" tabindex=\"-1\" @keydown=", ">\n\t\t\t\t<div class=\"top-alerts-container\"></div>\n\t\t\t\t", "\n\t\t\t\t<div class=\"not-supported\">\n\t\t\t\t\t<div class=\"message\">\n\t\t\t\t\t\t", "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"bottom-alerts-container\"></div>\n\t\t\t</div>\n\t\t\t", "\n\t\t\t", "\n\t\t"])), this.hideDocumentPreview ? 'hidden' : '', this.keyDown, this.bmCoreFileViewerOptionsReady() ? this.html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t<bm-core-file-viewer\n\t\t\t\t\t\t\t\tweb-viewer-path=\"", "\"\n\t\t\t\t\t\t\t\tedit-annotations=", "\n\t\t\t\t\t\t\t\tdocument-name=", "\n\t\t\t\t\t\t\t\tcustom-styles-path=\"", "\"\n\t\t\t\t\t\t\t\t.toolbarActions=", "\n\t\t\t\t\t\t\t\t@webViewerInstantiated=", "\n\t\t\t\t\t\t\t\t@documentLoaded=", "\n\t\t\t\t\t\t\t\t@documentUnloaded=", "\n\t\t\t\t\t\t\t\t@downloadClicked=", "\n\t\t\t\t\t\t\t\t@closeClicked=", "\n\t\t\t\t\t\t\t\t@documentLoadFailed=", "\n\t\t\t\t\t\t\t\t@lockedStateChanged=", "\n\t\t\t\t\t\t\t\t@documentRenamed=", "\n\t\t\t\t\t\t\t\t.options=", "\n\t\t\t\t\t\t\t\t.selectThumbnailPages=", "\n\t\t\t\t\t\t\t\t.isCombinePDFBrokenPdfMessage=", "\n\t\t\t\t\t\t\t></bm-core-file-viewer>"])), this.options.webViewerLibPath, this.editAnnotations, ifDefined(((_this$currentDocument2 = this.currentDocument) === null || _this$currentDocument2 === void 0 ? void 0 : _this$currentDocument2.name) || undefined), this.customStylesPath, this.toolbarActions, this.onWebViewerLoaded, this.onDocumentLoaded, this.onDocumentUnloaded, this.onDownloadClicked, this.closeCallback, this.onDocumentLoadFailed, this.onLockedStateChanged, this.onDocumentRenamed, this.bmCoreFileViewerOptions, this.customSelectMultiple, this.isCombinePDFBrokenPdfMessage) : nothing, this.options.strings.documentNotSupported, this.showWatermarkModal ? this.html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t<watermark-modal\n\t\t\t\t\t\t\t.strings=", "\n\t\t\t\t\t\t\t.watermarkSettings=", "\n\t\t\t\t\t\t\t@watermarkChanged=", "\n\t\t\t\t\t\t\t@watermarkModalClosed=", ">\n\t\t\t\t\t\t</watermark-modal>"])), this.options.strings, this.watermarkSettings, this.watermarkChangedHandler, this.watermarkModalClosedHandler) : nothing, this.showDownloadModal ? this.html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t<download-modal\n\t\t\t\t\t\t\t.showBusyLoader=", "\n\t\t\t\t\t\t\t.strings=", "\n\t\t\t\t\t\t\t.isPdfDocument=", "\n\t\t\t\t\t\t\t.annotationsAllowed=", "\n\t\t\t\t\t\t\t.hasWatermarks=", "\n\t\t\t\t\t\t\t.shouldFocus=", "\n\t\t\t\t\t\t\t@downloadDocument=", "\n\t\t\t\t\t\t\t@downloadModalClosed=", "\n\t\t\t\t\t\t\t@watermarkModalOpened=", ">\n\t\t\t\t\t\t</download-modal>"])), this.documentIsLoading || this.documentIsDownloading, this.options.strings, this.isPdfDocument, this.editAnnotations, checkIfWatermarkIsSet(this.watermarkSettings), !this.showWatermarkModal, this.downloadDocumentHandler, this.closeDownloadModalHandler, this.watermarkModalOpenedHandler) : nothing);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(DmsViewer, "connectedCallback", this, 3)([]);
      window.addEventListener('unload', this.unsubscribeFromServerNotifications.bind(this));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _superPropGet(DmsViewer, "disconnectedCallback", this, 3)([]);
      window.removeEventListener('unload', this.unsubscribeFromServerNotifications.bind(this));
      this.unsubscribeFromServerNotifications();
    }
  }, {
    key: "previousDocument",
    value: function previousDocument() {
      this.moveDocument(-1);
    }
  }, {
    key: "nextDocument",
    value: function nextDocument() {
      this.moveDocument(1);
    }
  }, {
    key: "initializeWebViewerInstance",
    value: function () {
      var _initializeWebViewerInstance = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;
        var webViewer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              webViewer = this.webViewer;
              webViewer.Core.documentViewer.addEventListener('pageComplete', this.onPageComplete.bind(this));
              webViewer.Core.documentViewer.addEventListener('annotationsLoaded', this.onAnnotationsLoaded.bind(this));
              webViewer.UI.iframeWindow.addEventListener('visibilityChanged', function (event) {
                var detail = event.detail;
                if (detail.element === PdfTronElement.passwordModal) {
                  _this2.toggleNavigationButtonsOpacity(detail.isVisible);
                  _this2.passwordModalIsVisible = detail.isVisible;
                  if (detail.isVisible) {
                    _this2.setLoadingState(false);
                    setTimeout(function () {
                      _this2.extractDocumentPassword();
                      _this2.disablePasswordAutocomplete();
                    }, 0);
                    _this2.emit(EventType.PasswordModal, detail.isVisible);
                  } else {
                    _this2.passwordEntered = false;
                    _this2.emit(EventType.PasswordSubmitted);
                  }
                }
                if (detail.element === PdfTronElement.printModal && detail.isVisible) {
                  configurePrintDialog(webViewer);
                }
                if (detail.element === PdfTronElement.filterModal && detail.isVisible) {
                  configureFilterModal(webViewer);
                }
              });
              this.setCurrentUser();
              webViewer.Core.annotationManager.setPermissionCheckCallback(function (_, annotation) {
                return annotation.Author === webViewer.Core.annotationManager.getCurrentUser();
              });
              webViewer.UI.addEventListener('outlineBookmarksChanged', this.onOutlineBookmarksChanged.bind(this));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initializeWebViewerInstance() {
        return _initializeWebViewerInstance.apply(this, arguments);
      }
      return initializeWebViewerInstance;
    }()
  }, {
    key: "disablePasswordAutocomplete",
    value: function disablePasswordAutocomplete() {
      var _webviewerDocument$qu;
      if (!this.webViewer) return;
      var webviewerDocument = this.webViewer.UI.iframeWindow.document;
      var passwordInput = (_webviewerDocument$qu = webviewerDocument.querySelector('[data-element="passwordModal"]')) === null || _webviewerDocument$qu === void 0 ? void 0 : _webviewerDocument$qu.querySelector('input');
      passwordInput.autocomplete = 'new-password';
    }
  }, {
    key: "extractDocumentPassword",
    value: function extractDocumentPassword() {
      var _UI$iframeWindow,
        _document$querySelect,
        _this3 = this;
      this.passwordPromise = deferred();
      var document = (_UI$iframeWindow = this.webViewer.UI.iframeWindow) === null || _UI$iframeWindow === void 0 ? void 0 : _UI$iframeWindow.document;
      var passwordSubmitButton = document.querySelector('[data-element="passwordSubmitButton"]');
      var passwordInput = (_document$querySelect = document.querySelector('[data-element="passwordModal"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelector('input');
      passwordInput === null || passwordInput === void 0 || passwordInput.addEventListener('keydown', function (e) {
        var enterKey = 'Enter';
        if (e.key === enterKey) {
          _this3.resolvePasswordPromise(passwordInput.value);
        }
      });
      passwordSubmitButton === null || passwordSubmitButton === void 0 || passwordSubmitButton.addEventListener('click', function () {
        _this3.resolvePasswordPromise(passwordInput.value);
      });
    }
  }, {
    key: "resolvePasswordPromise",
    value: function resolvePasswordPromise(passwordInput) {
      var _this$passwordPromise;
      if (this.passwordEntered) {
        this.passwordPromise = deferred();
      }
      (_this$passwordPromise = this.passwordPromise) === null || _this$passwordPromise === void 0 || _this$passwordPromise.resolve(passwordInput);
      this.passwordEntered = true;
    }
  }, {
    key: "setLoadingState",
    value: function setLoadingState(value) {
      if (value !== this.documentIsLoading) {
        this.documentIsLoading = value;
        this.emit(EventType.LoadingChange, this.documentIsLoading);
      }
    }
  }, {
    key: "onWebViewerLoaded",
    value: function onWebViewerLoaded(viewerLoadedEvent) {
      var _this4 = this;
      this.webViewer = viewerLoadedEvent.detail;
      this.viewerLoaded.resolve();
      var viewControlsButton = this.webViewer.UI.iframeWindow.document.querySelector('[data-element="viewControlsButton"]');
      if (this.webViewer.UI.pageManipulationOverlay) {
        void this.webViewer.UI.pageManipulationOverlay.disableOpeningByRightClick();
      }
      if (viewControlsButton) {
        viewControlsButton.tabIndex = 0;
      }
      this.setOnTriggeredHandler();
      var coreViewer = this.shadowRoot.querySelector('bm-core-file-viewer');
      coreViewer.options = coreViewer.options || {};
      void _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var viewControlsButton2;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.initializeWebViewerInstance();
            case 2:
              _context4.next = 4;
              return _this4.configureViewerAppearance();
            case 4:
              _this4.emit(EventType.WebViewerLoaded, {
                isWebviewerLoaded: true,
                instance: _this4.webViewer
              });
              viewControlsButton2 = _this4.webViewer.UI.iframeWindow.document.querySelector('[data-element="viewControlsButton"]');
              if (viewControlsButton2) {
                viewControlsButton2.tabIndex = 0;
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }, {
    key: "moveDocument",
    value: function moveDocument(direction) {
      if (this.siblings.length > 1 && !!this.document) {
        var i = this.getCurrentDocumentIndex();
        if (i >= 0) {
          var nextIndex = i + direction;
          if (nextIndex >= 0 && nextIndex <= this.siblings.length - 1) {
            this.emit(EventType.DocumentChange, this.siblings[nextIndex]);
          }
        }
      }
    }
  }, {
    key: "getCurrentDocumentIndex",
    value: function getCurrentDocumentIndex() {
      var _this5 = this;
      return this.document ? this.siblings.findIndex(function (key) {
        return key.id === _this5.document.id;
      }) : -1;
    }
  }, {
    key: "watchContainer",
    value: function watchContainer() {
      var _this6 = this;
      this.unsubscribeContainerChanges();
      this.containerSubscription = this.treeStore.observeChildrenKeys(this.container).subscribe(function (keys) {
        _this6.siblings = keys.filter(function (key) {
          return !isContainerKey(key);
        });
        if (!_this6.document && _this6.siblings.length > 0) {
          _this6.document = _this6.siblings[0];
          _this6.emit(EventType.DocumentChange, _this6.document);
        }
      });
      if (this.lastLoadedContainerId && this.lastLoadedContainerId !== this.container.id) {
        void this.treeStore.updateChildren(this.container);
      }
    }
  }, {
    key: "unsubscribeContainerChanges",
    value: function unsubscribeContainerChanges() {
      this.containerSubscription.unsubscribe();
    }
  }, {
    key: "resetPreviewModal",
    value: function resetPreviewModal() {
      var _this$webViewer2;
      var body = (_this$webViewer2 = this.webViewer) === null || _this$webViewer2 === void 0 || (_this$webViewer2 = _this$webViewer2.UI.iframeWindow) === null || _this$webViewer2 === void 0 ? void 0 : _this$webViewer2.document;
      var previewModal = body === null || body === void 0 ? void 0 : body.querySelector('.preview-modal');
      if (previewModal) {
        var documentContainer = body === null || body === void 0 ? void 0 : body.querySelector('.measurement-container');
        documentContainer === null || documentContainer === void 0 || documentContainer.removeChild(previewModal);
      }
    }
  }, {
    key: "collapseDropDowns",
    value: function collapseDropDowns() {
      var _this$webViewer3;
      (_this$webViewer3 = this.webViewer) === null || _this$webViewer3 === void 0 || _this$webViewer3.UI.closeElements([PdfTronElement.pageManipulationOverlay]);
    }
  }, {
    key: "focusViewer",
    value: function focusViewer() {
      var _this$renderRoot;
      var viewer = (_this$renderRoot = this.renderRoot) === null || _this$renderRoot === void 0 ? void 0 : _this$renderRoot.querySelector('.dms-viewer');
      viewer.focus();
    }
  }, {
    key: "loadDocument",
    value: function () {
      var _loadDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var silent,
          _this$currentDocument3,
          supportedByViewer,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              silent = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
              if (!(this.container && this.document)) {
                _context5.next = 11;
                break;
              }
              if (silent) {
                void this.storeViewport();
              } else {
                this.setLoadingState(true);
              }
              _context5.next = 5;
              return DiContainer.instance.documentService.get(this.document, this.container);
            case 5:
              this.currentDocument = _context5.sent;
              this.isPdfDocument = (_this$currentDocument3 = this.currentDocument) === null || _this$currentDocument3 === void 0 ? void 0 : _this$currentDocument3.name.endsWith('.pdf');
              supportedByViewer = isWebViewerClientSupported(this.currentDocument.name);
              this.isFileTypeSupported = supportedByViewer || this.currentDocument.canPreview;
              _context5.next = 11;
              return this.loadDocumentInWebviewer(this.currentDocument, this.container, !supportedByViewer && this.isFileTypeSupported);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function loadDocument() {
        return _loadDocument.apply(this, arguments);
      }
      return loadDocument;
    }()
  }, {
    key: "loadDocumentWithUrl",
    value: function () {
      var _loadDocumentWithUrl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$webViewer4;
        var documentCopy, data, byteArray, blob;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (this.documentUrl) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              _context6.next = 4;
              return this.viewerLoaded;
            case 4:
              if (this.webViewer) {
                _context6.next = 6;
                break;
              }
              return _context6.abrupt("return");
            case 6:
              _context6.next = 8;
              return (_this$webViewer4 = this.webViewer) === null || _this$webViewer4 === void 0 ? void 0 : _this$webViewer4.Core.createDocument(this.documentUrl, {
                extension: 'pdf'
              });
            case 8:
              documentCopy = _context6.sent;
              _context6.next = 11;
              return documentCopy === null || documentCopy === void 0 ? void 0 : documentCopy.getFileData();
            case 11:
              data = _context6.sent;
              if (!(!data || !this.webViewer)) {
                _context6.next = 14;
                break;
              }
              return _context6.abrupt("return");
            case 14:
              byteArray = new Uint8Array(data);
              blob = new Blob([byteArray], {
                type: 'application/pdf'
              });
              void this.webViewer.UI.loadDocument(blob);
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function loadDocumentWithUrl() {
        return _loadDocumentWithUrl.apply(this, arguments);
      }
      return loadDocumentWithUrl;
    }()
  }, {
    key: "loadDocumentInWebviewer",
    value: function () {
      var _loadDocumentInWebviewer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(document, container, convertToPdf) {
        var token, filename, documentOptions, documentArrayBuffer, coreViewer;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              token = cookie('UDSLongToken');
              if (token) {
                _context7.next = 4;
                break;
              }
              this.emit(EventType.AuthFailure, 'No token found');
              return _context7.abrupt("return");
            case 4:
              _context7.next = 6;
              return this.viewerLoaded;
            case 6:
              if (!this.annotationEditor) {
                _context7.next = 10;
                break;
              }
              _context7.next = 9;
              return this.annotationEditor.safeForDocumentUnload();
            case 9:
              this.annotationEditor = undefined;
            case 10:
              filename = document.name + (convertToPdf ? '.pdf' : '');
              documentOptions = {
                filename: filename,
                documentId: this.document.id
              };
              _context7.prev = 12;
              if (!this.options.useFetchApi) {
                _context7.next = 19;
                break;
              }
              _context7.next = 16;
              return DiContainer.instance.documentService.fetchDocumentArrayBuffer(document, container, convertToPdf);
            case 16:
              documentArrayBuffer = _context7.sent;
              _context7.next = 22;
              break;
            case 19:
              _context7.next = 21;
              return DiContainer.instance.documentService.getDocumentArrayBuffer(document, container, convertToPdf, {
                skipBlobSaving: true
              });
            case 21:
              documentArrayBuffer = _context7.sent;
            case 22:
              this.documentBlob = new Blob([documentArrayBuffer]);
              _context7.next = 29;
              break;
            case 25:
              _context7.prev = 25;
              _context7.t0 = _context7["catch"](12);
              this.documentBlob = new Blob();
              this.emit(EventType.DocumentLoadFailed, _context7.t0);
            case 29:
              if (document.id === this.document.id) {
                this.newDocumentName = undefined;
                coreViewer = this.shadowRoot.querySelector('bm-core-file-viewer');
                coreViewer.documentOptions = documentOptions;
                coreViewer.document = this.documentBlob;
              }
            case 30:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[12, 25]]);
      }));
      function loadDocumentInWebviewer(_x2, _x3, _x4) {
        return _loadDocumentInWebviewer.apply(this, arguments);
      }
      return loadDocumentInWebviewer;
    }()
  }, {
    key: "insertPageAtCertainIndexIntoDocument",
    value: function () {
      var _insertPageAtCertainIndexIntoDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(pageDataUrl) {
        var coreDoc, documentViewer, currentDoc;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.pageTobeInserted(pageDataUrl);
            case 2:
              coreDoc = _context8.sent;
              documentViewer = this.webViewer.Core.documentViewer;
              currentDoc = documentViewer.getDocument();
              if (!currentDoc) {
                _context8.next = 8;
                break;
              }
              _context8.next = 8;
              return currentDoc.insertPages(coreDoc, undefined, this === null || this === void 0 ? void 0 : this.pageNo);
            case 8:
              this.isPageInserted = true;
              this.emit(EventType.NewPageInserted, true);
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function insertPageAtCertainIndexIntoDocument(_x5) {
        return _insertPageAtCertainIndexIntoDocument.apply(this, arguments);
      }
      return insertPageAtCertainIndexIntoDocument;
    }()
  }, {
    key: "pageTobeInserted",
    value: function () {
      var _pageTobeInserted = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(pageDataURL) {
        var PDFNet, newDoc, builder, writer, pageRectWidth, pageRectHeight, pageRect, page, a, b, c, d, h, v, img, element, coreDoc;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              PDFNet = this.webViewer.Core.PDFNet;
              _context9.next = 3;
              return PDFNet.initialize();
            case 3:
              _context9.next = 5;
              return PDFNet.PDFDoc.create();
            case 5:
              newDoc = _context9.sent;
              _context9.next = 8;
              return PDFNet.ElementBuilder.create();
            case 8:
              builder = _context9.sent;
              _context9.next = 11;
              return PDFNet.ElementWriter.create();
            case 11:
              writer = _context9.sent;
              pageRectWidth = 612;
              pageRectHeight = 794;
              _context9.next = 16;
              return PDFNet.Rect.init(0, 0, pageRectWidth, pageRectHeight);
            case 16:
              pageRect = _context9.sent;
              _context9.next = 19;
              return newDoc.pageCreate(pageRect);
            case 19:
              page = _context9.sent;
              _context9.next = 22;
              return writer.beginOnPage(page);
            case 22:
              a = 600;
              b = 0;
              c = 0;
              d = 600;
              h = 0;
              v = 100;
              _context9.next = 30;
              return PDFNet.Image.createFromURL(newDoc, pageDataURL);
            case 30:
              img = _context9.sent;
              _context9.t0 = builder;
              _context9.t1 = img;
              _context9.next = 35;
              return PDFNet.Matrix2D.create(a, b, c, d, h, v);
            case 35:
              _context9.t2 = _context9.sent;
              _context9.next = 38;
              return _context9.t0.createImageFromMatrix.call(_context9.t0, _context9.t1, _context9.t2);
            case 38:
              element = _context9.sent;
              _context9.next = 41;
              return writer.writePlacedElement(element);
            case 41:
              _context9.next = 43;
              return writer.end();
            case 43:
              _context9.next = 45;
              return newDoc.pagePushBack(page);
            case 45:
              _context9.next = 47;
              return this.webViewer.Core.createDocument(newDoc);
            case 47:
              coreDoc = _context9.sent;
              return _context9.abrupt("return", coreDoc);
            case 49:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function pageTobeInserted(_x6) {
        return _pageTobeInserted.apply(this, arguments);
      }
      return pageTobeInserted;
    }()
  }, {
    key: "insertPageIntoDocument",
    value: function () {
      var _insertPageIntoDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(pageDataURL) {
        var coreDoc, documentViewer, currentDoc, coreViewer, pageIndex;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.pageTobeInserted(pageDataURL);
            case 2:
              coreDoc = _context10.sent;
              documentViewer = this.webViewer.Core.documentViewer;
              currentDoc = documentViewer.getDocument();
              if (!(!currentDoc || currentDoc.getPageCount() < 1)) {
                _context10.next = 10;
                break;
              }
              coreViewer = this.shadowRoot.querySelector('bm-core-file-viewer');
              if (!this.document) coreViewer.document = coreDoc;
              _context10.next = 14;
              break;
            case 10:
              pageIndex = currentDoc.getPageCount() + 1;
              if (this.document) {
                _context10.next = 14;
                break;
              }
              _context10.next = 14;
              return currentDoc.insertPages(coreDoc, undefined, pageIndex);
            case 14:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function insertPageIntoDocument(_x7) {
        return _insertPageIntoDocument.apply(this, arguments);
      }
      return insertPageIntoDocument;
    }()
  }, {
    key: "insertMultiplePagesIntoDocument",
    value: function () {
      var _insertMultiplePagesIntoDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(pdfDataURL) {
        var _this$webViewer5;
        var documentCopy, documentViewer, currentDoc, data, byteArray, blob;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.viewerLoaded;
            case 2:
              if (this.webViewer) {
                _context11.next = 4;
                break;
              }
              return _context11.abrupt("return");
            case 4:
              _context11.next = 6;
              return (_this$webViewer5 = this.webViewer) === null || _this$webViewer5 === void 0 ? void 0 : _this$webViewer5.Core.createDocument(pdfDataURL, {
                extension: 'pdf'
              });
            case 6:
              documentCopy = _context11.sent;
              documentViewer = this.webViewer.Core.documentViewer;
              currentDoc = documentViewer.getDocument();
              if (!(this.documentUrl || this.document)) {
                _context11.next = 14;
                break;
              }
              _context11.next = 12;
              return currentDoc.insertPages(documentCopy, undefined, this.pageNo);
            case 12:
              if (this.document) {
                this.emit(EventType.NewPageInserted, true);
              }
              return _context11.abrupt("return");
            case 14:
              _context11.next = 16;
              return documentCopy === null || documentCopy === void 0 ? void 0 : documentCopy.getFileData();
            case 16:
              data = _context11.sent;
              if (!(!data || !this.webViewer)) {
                _context11.next = 19;
                break;
              }
              return _context11.abrupt("return");
            case 19:
              byteArray = new Uint8Array(data);
              blob = new Blob([byteArray], {
                type: 'application/pdf'
              });
              void this.webViewer.UI.loadDocument(blob);
            case 22:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function insertMultiplePagesIntoDocument(_x8) {
        return _insertMultiplePagesIntoDocument.apply(this, arguments);
      }
      return insertMultiplePagesIntoDocument;
    }()
  }, {
    key: "setCurrentUser",
    value: function setCurrentUser() {
      if (this.webViewer) {
        var annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
        annotationManager.setCurrentUser(this.userDisplayAs ? this.userDisplayAs : 'Unknown');
      }
    }
  }, {
    key: "onPageComplete",
    value: function onPageComplete(pageIndex) {
      if (pageIndex === 1) {
        if (!this.loadSavedAnnotations) {
          this.setLoadingState(false);
        }
        this.emit(EventType.DocumentMetadataLoaded, {
          totalPages: this.webViewer.Core.documentViewer.getPageCount()
        });
        this.suspendLayoutChangeEvent = false;
      }
    }
  }, {
    key: "emitBlob",
    value: function () {
      var _emitBlob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var doc, fileData, documentCopyBlob, pageDataUrl, blobData;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              doc = this.webViewer.Core.documentViewer.getDocument();
              _context12.next = 3;
              return doc.getFileData();
            case 3:
              fileData = _context12.sent;
              documentCopyBlob = new Blob([new Uint8Array(fileData)]);
              pageDataUrl = URL.createObjectURL(documentCopyBlob);
              blobData = {
                blob: documentCopyBlob,
                pageData: pageDataUrl
              };
              this.emit(EventType.DocumentBlob, blobData);
            case 8:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function emitBlob() {
        return _emitBlob.apply(this, arguments);
      }
      return emitBlob;
    }()
  }, {
    key: "emitAnnotations",
    value: function () {
      var _emitAnnotations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var annotationManager, exportedAnnotations, parts, annotationFile;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
              _context13.next = 3;
              return exportAnnotations(annotationManager);
            case 3:
              exportedAnnotations = _context13.sent;
              parts = [new Blob([exportedAnnotations], {
                type: 'text/plain'
              })];
              annotationFile = new File(parts, 'metaData.xfdf');
              this.emit(EventType.DocumentAnnotations, annotationFile);
            case 7:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function emitAnnotations() {
        return _emitAnnotations.apply(this, arguments);
      }
      return emitAnnotations;
    }()
  }, {
    key: "emitLatestPageData",
    value: function () {
      var _emitLatestPageData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this$webViewer6;
        var doc, fileData, documentCopyBlob, pageDataUrl, pageCount;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              doc = this.webViewer.Core.documentViewer.getDocument();
              _context14.next = 3;
              return doc.getFileData();
            case 3:
              fileData = _context14.sent;
              documentCopyBlob = new Blob([new Uint8Array(fileData)]);
              pageDataUrl = URL.createObjectURL(documentCopyBlob);
              pageCount = (_this$webViewer6 = this.webViewer) === null || _this$webViewer6 === void 0 ? void 0 : _this$webViewer6.Core.documentViewer.getPageCount();
              this.emit(EventType.DocumentPageData, {
                pageDataUrl: pageDataUrl,
                pageCount: pageCount
              });
            case 8:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function emitLatestPageData() {
        return _emitLatestPageData.apply(this, arguments);
      }
      return emitLatestPageData;
    }()
  }, {
    key: "onLayoutChanged",
    value: function onLayoutChanged(changes) {
      var _this$webViewer7,
        _this7 = this;
      var pageNo = (_this$webViewer7 = this.webViewer) === null || _this$webViewer7 === void 0 ? void 0 : _this$webViewer7.Core.documentViewer.getPageCount();
      this.emit(EventType.TotalPages, pageNo);
      if (!this.suspendLayoutChangeEvent && this.document && this.container && !this.options.isThumbnailsOnlyMode) {
        if (this.allowDocumentUpdate(this.document)) {
          this.annotationEditor.processRequest(new DocumentUpdate(this.container, this.document.id, changes));
        }
      }
      changes.contentChanged.forEach(function (pageNumber) {
        var rotation = _this7.webViewer.Core.documentViewer.getDocument().getPageRotation(pageNumber);
        _this7.emit(EventType.DocumentContentChanged, {
          pageNumber: pageNumber,
          rotationAngle: rotation
        });
      });
      changes.removed.forEach(function (pageNumber) {
        _this7.emit(EventType.DocumentPageRemoved, {
          pageNumber: pageNumber
        });
      });
    }
  }, {
    key: "onOutlineBookmarksChanged",
    value: function onOutlineBookmarksChanged(data) {
      if (data && this.document && this.container) {
        var added = [];
        var deleted = [];
        var contents = [];
        var moved = {};
        this.onLayoutChanged(new DocumentChanges(added, contents, moved, deleted));
      }
    }
  }, {
    key: "onDocumentUpdateAction",
    value: function onDocumentUpdateAction() {
      this.emit(EventType.DocumentUpdateAction, {
        id: this.document.id
      });
    }
  }, {
    key: "allowDocumentUpdate",
    value: function allowDocumentUpdate(document) {
      var fileExtension = document.fileExtension;
      return !['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpg', 'jpeg', 'jfif'].includes(fileExtension);
    }
  }, {
    key: "getDocumentBlob",
    value: function () {
      var _getDocumentBlob = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var annotationManager, widgetList, xfdfString, doc, data, arr, blob, file;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
              widgetList = annotationManager.getAnnotationsList().filter(function (annot) {
                return annot.Subject === 'Widget';
              });
              _context15.next = 4;
              return annotationManager.exportAnnotations({
                annotList: widgetList,
                fields: true,
                widgets: true,
                links: true
              });
            case 4:
              xfdfString = _context15.sent;
              doc = this.webViewer.Core.documentViewer.getDocument();
              _context15.next = 8;
              return doc.getFileData({
                xfdfString: xfdfString
              });
            case 8:
              data = _context15.sent;
              arr = new Uint8Array(data);
              blob = new Blob([arr], {
                type: 'application/pdf'
              });
              file = new File([blob], doc.getFilename(), undefined);
              return _context15.abrupt("return", file);
            case 13:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function getDocumentBlob() {
        return _getDocumentBlob.apply(this, arguments);
      }
      return getDocumentBlob;
    }()
  }, {
    key: "onDocumentLoaded",
    value: function onDocumentLoaded() {
      var _this8 = this;
      if (this.webViewer) {
        var _this$document, _this$options$zoom, _Core$documentViewer;
        var defaultZoomValue = 1.2;
        this.suspendLayoutChangeEvent = true;
        this.emit(EventType.LoadedDocumentChange, (_this$document = this.document) === null || _this$document === void 0 ? void 0 : _this$document.id);
        if (!this.isPageInserted) {
          var _this$document2;
          this.emit(EventType.ExistingDocumentLoaded, (_this$document2 = this.document) === null || _this$document2 === void 0 ? void 0 : _this$document2.id);
        }
        var annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
        var editController = new AnnotationEditController(this.document, this.annotationsService, this.documentService, /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(annotations) {
            return _regeneratorRuntime.wrap(function _callee16$(_context16) {
              while (1) switch (_context16.prev = _context16.next) {
                case 0:
                  return _context16.abrupt("return", exportAnnotations(annotationManager, annotations));
                case 1:
                case "end":
                  return _context16.stop();
              }
            }, _callee16);
          }));
          return function (_x9) {
            return _ref2.apply(this, arguments);
          };
        }(), this.getDocumentBlob.bind(this), defaultDebounceIntervalMilliseconds, this.options.strings, this.onDocumentUpdateAction.bind(this), function (message) {
          return addClosableAlert(AlertLocation.bottom, AlertType.danger, message, _this8.getShadowRootNode());
        }, this.webSocketSubscriberId, undefined, this.options.useFetchApi);
        this.annotationEditor = editController;
        this.webViewer.UI.setZoomLevel((_this$options$zoom = this.options.zoom) !== null && _this$options$zoom !== void 0 ? _this$options$zoom : defaultZoomValue);
        if (this.editAnnotations) {
          this.setupAnnotationsEdit();
        }
        if (this.loadSavedAnnotations) {
          this.setTextSelectTool();
          void this.loadAnnotations();
        }
        if (this.subscribeForNotifications) {
          this.subscribeForServerNotifications();
        }
        var _Core = this.webViewer.Core;
        var displayModeManager = _Core === null || _Core === void 0 || (_Core$documentViewer = _Core.documentViewer) === null || _Core$documentViewer === void 0 ? void 0 : _Core$documentViewer.getDisplayModeManager();
        if (displayModeManager !== null && displayModeManager !== void 0 && displayModeManager.disableVirtualDisplayMode) {
          displayModeManager.disableVirtualDisplayMode();
        }
        var displayMode = new _Core.DisplayMode(_Core.documentViewer, _Core.DisplayModes.Continuous, true);
        _Core.documentViewer.getDisplayModeManager().setDisplayMode(displayMode);
        void this.restoreViewportIfAvailable();
        this.documentChangedHandler = this.onLayoutChanged.bind(this);
        this.webViewer.Core.documentViewer.addEventListener('pagesUpdated', this.documentChangedHandler);
        var pageNo = this.webViewer.Core.documentViewer.getPageCount();
        this.emit(EventType.TotalPages, pageNo);
        if (!this.options.disableFormInputs) {
          this.setupFormFieldEdit();
        }
        this.watermarkSettings = null;
        this.showPrintButton = true;
        this.configureHotkeys();
      }
    }
  }, {
    key: "loadAnnotations",
    value: function () {
      var _loadAnnotations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var annotations, annotationManager, annotationsList;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.getAnnotationsForCurrentDocument();
            case 2:
              annotations = _context17.sent;
              if (this.document && annotations) {
                annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
                this.suspendAnnotationChangeEvent = true;
                void annotationManager.importAnnotations(annotations);
                annotationsList = annotationManager.getAnnotationsList();
                annotationsList.forEach(restoreLineBreaks);
                if (!this.editAnnotations) {
                  annotationManager.enableReadOnlyMode();
                }
                this.suspendAnnotationChangeEvent = false;
              }
              configureDownloadButton(this.webViewer, this.options, this.showCustomDownloadModal.bind(this));
              this.setLoadingState(false);
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function loadAnnotations() {
        return _loadAnnotations.apply(this, arguments);
      }
      return loadAnnotations;
    }()
  }, {
    key: "getAnnotationsForCurrentDocument",
    value: function () {
      var _getAnnotationsForCurrentDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var capturedDocumentId, annotations;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              capturedDocumentId = this.document.id;
              _context18.next = 3;
              return this.annotationsService.getAnnotations(this.document.id);
            case 3:
              annotations = _context18.sent.annotations;
              if (!(this.document && capturedDocumentId === this.document.id)) {
                _context18.next = 6;
                break;
              }
              return _context18.abrupt("return", annotations);
            case 6:
              return _context18.abrupt("return", undefined);
            case 7:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function getAnnotationsForCurrentDocument() {
        return _getAnnotationsForCurrentDocument.apply(this, arguments);
      }
      return getAnnotationsForCurrentDocument;
    }()
  }, {
    key: "onAnnotationsLoaded",
    value: function onAnnotationsLoaded() {
      this.configureFields();
    }
  }, {
    key: "configureFields",
    value: function configureFields() {
      var _this$webViewer8,
        _this9 = this;
      var fieldManager = (_this$webViewer8 = this.webViewer) === null || _this$webViewer8 === void 0 || (_this$webViewer8 = _this$webViewer8.Core) === null || _this$webViewer8 === void 0 || (_this$webViewer8 = _this$webViewer8.documentViewer) === null || _this$webViewer8 === void 0 || (_this$webViewer8 = _this$webViewer8.getAnnotationManager()) === null || _this$webViewer8 === void 0 ? void 0 : _this$webViewer8.getFieldManager();
      if (!fieldManager) {
        return;
      }
      fieldManager.forEachField(function (item) {
        _this9.configureFormField(item, _this9.options.disableFormInputs);
        if (!_this9.options.disableFormInputs) {
          _this9.configureFormField(item, true, function (item) {
            return item.fieldFlags.get('PushButton');
          });
        }
      });
    }
  }, {
    key: "configureFormField",
    value: function configureFormField(field) {
      var _this10 = this;
      var isDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filter = arguments.length > 2 ? arguments[2] : undefined;
      if (field.widgets) {
        field.widgets.filter(filter !== null && filter !== void 0 ? filter : function (_) {
          return true;
        }).forEach(function (widget) {
          widget.fieldFlags.set('ReadOnly', isDisabled);
          widget.ReadOnly = isDisabled;
          widget.Locked = isDisabled;
          widget.LockedContents = isDisabled;
        });
      }
      if (field.children) {
        field.children.forEach(function (item) {
          return _this10.configureFormField(item, isDisabled, filter);
        });
      }
    }
  }, {
    key: "onFieldChanged",
    value: function onFieldChanged(field, value) {
      if (!this.suspendLayoutChangeEvent && this.document && this.container) {
        if (this.webViewer && this.allowDocumentUpdate(this.document)) {
          this.annotationEditor.processRequest(new DocumentUpdate(this.container, this.document.id, {
            field: field,
            value: value
          }));
        }
      }
    }
  }, {
    key: "onDocumentUnloaded",
    value: function onDocumentUnloaded() {
      if (this.loadSavedAnnotations && this.editAnnotations) {
        this.stopEditingAnnotations();
      }
      this.showPrintButton = false;
      this.stopEditingDocument();
      this.stopEditingFillableForm();
      this.emit(EventType.LoadedDocumentChange, undefined);
    }
  }, {
    key: "onDocumentLoadFailed",
    value: function onDocumentLoadFailed(error) {
      this.setLoadingState(false);
      if (!this.isFileTypeSupported) {
        this.emit(EventType.DocumentNotSupported, true);
        return;
      }
      if (this.isFileTypeSupported) {
        var _this$currentDocument4, _this$currentDocument5;
        this.isDocumentValid = false;
        this.emit(EventType.DocumentLoadFailed, true);
        if (this.hideDocumentPreview && this.showDownloadModal) {
          this.closeDownloadModalHandler();
          void downloadDocument(this.document, this.container);
        }
        var errorMessage = typeof error.detail === 'string' ? error.detail : JSON.stringify(error.detail);
        console.error("PDFTron error: loading document into the viewer: DocumentID ".concat((_this$currentDocument4 = (_this$currentDocument5 = this.currentDocument) === null || _this$currentDocument5 === void 0 ? void 0 : _this$currentDocument5.id) !== null && _this$currentDocument4 !== void 0 ? _this$currentDocument4 : '', ". ").concat(errorMessage));
      }
    }
  }, {
    key: "onLockedStateChanged",
    value: function onLockedStateChanged(event) {
      var _this$options$headerO;
      var readonly = !!event.detail;
      var prevOptions = JSON.parse(JSON.stringify(this.options));
      this.options.readonly = readonly;
      this.options.disableFormInputs = readonly && this.isPdfDocument;
      this.options.headerOptions = _objectSpread(_objectSpread({}, (_this$options$headerO = this.options.headerOptions) !== null && _this$options$headerO !== void 0 ? _this$options$headerO : {}), {}, {
        openDisabled: readonly,
        moveDisabled: readonly,
        renameDisabled: readonly,
        insertScanDisabled: readonly || !this.isPdfDocument,
        deleteDisabled: readonly,
        approveDisabled: readonly,
        unlockDisabled: !readonly
      });
      this.options.disableEditingOutlines = readonly;
      this.configureFields();
      void this.configureViewerAppearance(prevOptions);
    }
  }, {
    key: "onDocumentRenamed",
    value: function onDocumentRenamed(event) {
      this.newDocumentName = event.detail;
      this.lastLoadedDocumentName = event.detail;
    }
  }, {
    key: "onDownloadClicked",
    value: function onDownloadClicked(event) {
      var _event$detail;
      if ((_event$detail = event.detail) !== null && _event$detail !== void 0 && _event$detail.customDownload && this.canPreviewDocument && !this.passwordModalIsVisible) {
        this.showCustomDownloadModal();
      } else {
        void downloadDocument(this.document, this.container);
      }
    }
  }, {
    key: "setupAnnotationsEdit",
    value: function setupAnnotationsEdit() {
      if (this.webViewer) {
        var annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
        this.annotationChangedHandler = this.onAnnotationChanged.bind(this);
        annotationManager.addEventListener('annotationChanged', this.annotationChangedHandler);
        this.annotationEditState = this.annotationEditor;
      }
    }
  }, {
    key: "setupFormFieldEdit",
    value: function setupFormFieldEdit() {
      if (this.webViewer) {
        this.formInputsChangedHandler = this.onFieldChanged.bind(this);
        var annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
        annotationManager.addEventListener('fieldChanged', this.formInputsChangedHandler);
        this.fieldEditTracker = new (dmsViewerFieldEditTrackerConstructor())(this.webViewer);
      }
      if (this.finalizationFunctionContainer) {
        this.finalizationFunctionContainer.fn = this.savePendingChanges.bind(this);
      }
    }
  }, {
    key: "stopEditingAnnotations",
    value: function stopEditingAnnotations() {
      if (this.webViewer && this.annotationChangedHandler) {
        var annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
        annotationManager.removeEventListener('annotationChanged', this.annotationChangedHandler);
      }
    }
  }, {
    key: "stopEditingDocument",
    value: function stopEditingDocument() {
      if (this.webViewer && this.documentChangedHandler) {
        var documentViewer = this.webViewer.Core.documentViewer;
        documentViewer.removeEventListener('pagesUpdated', this.documentChangedHandler);
      }
    }
  }, {
    key: "stopEditingFillableForm",
    value: function stopEditingFillableForm() {
      if (this.webViewer && this.formInputsChangedHandler) {
        var annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
        annotationManager.removeEventListener('fieldChanged', this.formInputsChangedHandler);
      }
    }
  }, {
    key: "onAnnotationChanged",
    value: function onAnnotationChanged(annotations, action, info) {
      if (!this.suspendAnnotationChangeEvent && !info.imported && this.userContactId) {
        var modifications = [];
        if (action === AnnotationAction.Delete) {
          var _iterator = _createForOfIteratorHelper(annotations),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var annotation = _step.value;
              if (annotation.Subject !== 'Note' || annotation.InReplyTo) {
                modifications.push(new AnnotationDelete(annotation.Id));
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else if (action === AnnotationAction.Add || action === AnnotationAction.Modify) {
          var contactIdCustomDataKey = 'contactId';
          var ModificationCtor = action === AnnotationAction.Add ? AnnotationCreate : AnnotationEdit;
          var _iterator2 = _createForOfIteratorHelper(annotations),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _annotation = _step2.value;
              _annotation.setCustomData(contactIdCustomDataKey, this.userContactId);
              storeLineBreaksInfo(_annotation);
              modifications.push(new ModificationCtor(_annotation.Id, _annotation));
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        modifications.forEach(this.annotationEditor.processRequest.bind(this.annotationEditor));
      }
    }
  }, {
    key: "emit",
    value: function emit(type, payload) {
      this.dispatchEvent(new CustomEvent(type, {
        detail: payload
      }));
    }
  }, {
    key: "addNavigationButtons",
    value: function addNavigationButtons() {
      var style = document.createElement('style');
      style.innerHTML = navigationButtonStyles + footerStyles;
      var body = this.webViewer.UI.iframeWindow.document;
      var documentContainer = body.querySelector('.document-content-container');
      documentContainer.parentNode.insertBefore(style, documentContainer);
      var passwordModal = body.querySelector('.PasswordModal');
      var navigationButtonsDiv = document.createElement('div');
      navigationButtonsDiv.style.width = 'inherit';
      navigationButtonsDiv.style.position = 'absolute';
      navigationButtonsDiv.style.top = '50%';
      documentContainer === null || documentContainer === void 0 || documentContainer.appendChild(navigationButtonsDiv);
      var leftNavigationButtons = [this.createNavigationButton(navigationButtonsDiv, 'left', !this.hasPreviousDocument, this.options.strings.navigationButtonLeft, this.previousDocument.bind(this), 'bento-icon-chevron-left'), this.createNavigationButton(passwordModal, 'left', !this.hasPreviousDocument, this.options.strings.navigationButtonLeft, this.previousDocument.bind(this), 'bento-icon-chevron-left')];
      var rightNavigationButtons = [this.createNavigationButton(navigationButtonsDiv, 'right', !this.hasNextDocument, this.options.strings.navigationButtonRight, this.nextDocument.bind(this), 'bento-icon-chevron-right'), this.createNavigationButton(passwordModal, 'right', !this.hasNextDocument, this.options.strings.navigationButtonRight, this.nextDocument.bind(this), 'bento-icon-chevron-right')];
      this.updateNavigationButtons(leftNavigationButtons, rightNavigationButtons);
      this.navigationButtons = [leftNavigationButtons, rightNavigationButtons];
      this.contentAreaNavigationButtons = [leftNavigationButtons[0], rightNavigationButtons[0]];
    }
  }, {
    key: "createNavigationButton",
    value: function createNavigationButton(documentContainer, position, disabled, title, onClick, iconStyle) {
      var button = document.createElement('button');
      button.classList.add('navigation-button', position);
      button.type = 'button';
      button.disabled = disabled;
      button.title = title;
      button.onclick = onClick;
      var iconSpanLeft = document.createElement('span');
      iconSpanLeft.classList.add(iconStyle);
      button.appendChild(iconSpanLeft);
      if (documentContainer) documentContainer.append(button);
      return button;
    }
  }, {
    key: "updateNavigationButtons",
    value: function updateNavigationButtons(leftNavigationButtons, rightNavigationButtons) {
      var _this11 = this;
      var i = this.getCurrentDocumentIndex();
      leftNavigationButtons.forEach(function (b) {
        return b.disabled = !(i > 0);
      });
      rightNavigationButtons.forEach(function (b) {
        return b.disabled = !(i > -1 && i < _this11.siblings.length - 1);
      });
    }
  }, {
    key: "configureViewerAppearance",
    value: function () {
      var _configureViewerAppearance = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(prevOptions) {
        var _this12 = this;
        var zoomLevel, enabledElements;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (this.webViewer) {
                _context19.next = 2;
                break;
              }
              return _context19.abrupt("return");
            case 2:
              zoomLevel = this.webViewer.UI.getZoomLevel();
              if (prevOptions) {
                resetViewerOptions(this.webViewer, prevOptions, this.getShadowRootNode());
              }
              _context19.next = 6;
              return configureWebViewer(this.webViewer, this.options);
            case 6:
              this.webViewer.UI.setZoomLevel(zoomLevel);
              if (this.loadSavedAnnotations) {
                configureDownloadButton(this.webViewer, this.options, this.showCustomDownloadModal.bind(this));
              }
              enabledElements = Object.values(PdfTronElement).filter(function (element) {
                var _this12$webViewer;
                return !((_this12$webViewer = _this12.webViewer) !== null && _this12$webViewer !== void 0 && _this12$webViewer.UI.isElementDisabled(element));
              }).map(function (element) {
                return element;
              });
              if (this.options.showNavigationArrows) {
                this.addNavigationButtons();
              }
              this.bmCoreFileViewerOptions = _objectSpread(_objectSpread({}, this.bmCoreFileViewerOptions), {}, {
                enabledElements: this.isDocumentValid ? enabledElements : [],
                disableDefaultElements: this.options.disableDefaultPdfTronElements || !this.isDocumentValid,
                showPageNavOverlayButtons: this.options.showPageNavOverlayButtons,
                showViewControlsDropdown: this.options.enableViewControlAndMenu,
                showCogMenu: this.options.enableViewControlAndMenu,
                showHighlightTool: this.options.showHighlightTool,
                showFreeTextTool: this.options.showFreeTextTool,
                enablePrintHotKey: this.options.enablePrintHotKey,
                headerOptions: _objectSpread({}, this.options.headerOptions),
                readonly: this.options.readonly,
                showHeader: this.options.showHeader,
                isThumbnailsOnlyMode: this.options.isThumbnailsOnlyMode,
                showMultiSelectForThumbnail: this.options.showMultiSelectForThumbnail,
                isCombineDocuments: this.options.isCombineDocuments,
                hideMoveButtonsForThumbnail: this.options.hideMoveButtonsForThumbnail,
                editable: this.options.editable,
                zoomLevel: this.options.zoom
              });
            case 11:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function configureViewerAppearance(_x10) {
        return _configureViewerAppearance.apply(this, arguments);
      }
      return configureViewerAppearance;
    }()
  }, {
    key: "setTextSelectTool",
    value: function setTextSelectTool() {
      this.webViewer.UI.setToolMode(this.webViewer.Core.Tools.ToolNames.TEXT_SELECT);
    }
  }, {
    key: "toggleNavigationButtonsOpacity",
    value: function toggleNavigationButtonsOpacity(passwordModalVisible) {
      if (passwordModalVisible) {
        var _this$contentAreaNavi;
        (_this$contentAreaNavi = this.contentAreaNavigationButtons) === null || _this$contentAreaNavi === void 0 || _this$contentAreaNavi.forEach(function (b) {
          return b.style.setProperty('opacity', '0');
        });
      } else {
        var _this$contentAreaNavi2;
        (_this$contentAreaNavi2 = this.contentAreaNavigationButtons) === null || _this$contentAreaNavi2 === void 0 || _this$contentAreaNavi2.forEach(function (b) {
          return b.style.removeProperty('opacity');
        });
      }
    }
  }, {
    key: "subscribeForServerNotifications",
    value: function subscribeForServerNotifications() {
      if (!this.websocketService) {
        this.websocketService = new (webSocketServiceConstructor())({
          ssl: true,
          connectPath: '/connect',
          reconnectAttempts: 5,
          reconnectOnError: false,
          log: console.log
        });
      }
      void this.websocketService.subscribe('com.tr.bluemoon.event.dms.document.updated.v1', this.document.id, this.notifyDocumentUpdated.bind(this), console.log, documentUpdateEventFieldRenameMap);
    }
  }, {
    key: "unsubscribeFromServerNotifications",
    value: function unsubscribeFromServerNotifications() {
      if (this.websocketService) {
        this.websocketService.close();
        this.websocketService = undefined;
      }
    }
  }, {
    key: "notifyDocumentUpdated",
    value: function notifyDocumentUpdated(event) {
      if (!this.document) {
        return;
      }
      if (event.documentId !== this.document.id) {
        return;
      }
      if (this.documentIsLoading) {
        return;
      }
      if (event.initiatorId !== this.webSocketSubscriberId) {
        if (event.eventType === WebSocketEventType.DocumentUpdated) {
          this.unsubscribeFromServerNotifications();
          void this.loadDocument(true);
        } else if (event.eventType === WebSocketEventType.AnnotationsUpdated) {
          void this.refreshAnnotations();
        }
      }
    }
  }, {
    key: "refreshAnnotations",
    value: function () {
      var _refreshAnnotations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var _yield$this$getAnnota, annotations, annotationManager;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!this.loadSavedAnnotations) {
                _context20.next = 18;
                break;
              }
              _context20.next = 3;
              return this.getAnnotationsForCurrentDocument();
            case 3:
              _context20.t1 = _yield$this$getAnnota = _context20.sent;
              _context20.t0 = _context20.t1 !== null;
              if (!_context20.t0) {
                _context20.next = 7;
                break;
              }
              _context20.t0 = _yield$this$getAnnota !== void 0;
            case 7:
              if (!_context20.t0) {
                _context20.next = 11;
                break;
              }
              _context20.t2 = _yield$this$getAnnota;
              _context20.next = 12;
              break;
            case 11:
              _context20.t2 = BLANK_ANNOTATIONS_XFDF;
            case 12:
              annotations = _context20.t2;
              annotationManager = this.webViewer.Core.documentViewer.getAnnotationManager();
              this.suspendAnnotationChangeEvent = true;
              _context20.next = 17;
              return this.annotationEditState.refreshAnnotations(annotationManager, annotations);
            case 17:
              this.suspendAnnotationChangeEvent = false;
            case 18:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function refreshAnnotations() {
        return _refreshAnnotations.apply(this, arguments);
      }
      return refreshAnnotations;
    }()
  }, {
    key: "storeViewport",
    value: function storeViewport() {
      var scrollEl = this.webViewer.Core.documentViewer.getScrollViewElement();
      this.viewport = {
        top: scrollEl.scrollTop,
        left: scrollEl.scrollLeft,
        zoomLevel: this.webViewer.UI.getZoomLevel()
      };
    }
  }, {
    key: "restoreViewportIfAvailable",
    value: function restoreViewportIfAvailable() {
      if (this.viewport) {
        this.webViewer.UI.setZoomLevel(this.viewport.zoomLevel);
        var scrollEl = this.webViewer.Core.documentViewer.getScrollViewElement();
        scrollEl.scrollTo(this.viewport.left, this.viewport.top);
        this.viewport = undefined;
      }
    }
  }, {
    key: "configureHotkeys",
    value: function configureHotkeys() {
      if (!this.webViewer) return;
      this.webViewer.UI.hotkeys.on("".concat(this.webViewer.UI.hotkeys.Keys.CTRL_P, ", ").concat(this.webViewer.UI.hotkeys.Keys.COMMAND_P), function (event) {
        event.preventDefault();
      });
      if (this.options.hideMoveButtonsForThumbnail && !this.options.showMultiSelectForThumbnail) {
        this.webViewer.UI.hotkeys.off();
      }
    }
  }, {
    key: "showCustomDownloadModal",
    value: function showCustomDownloadModal() {
      var _this$watermarkSettin;
      this.showDownloadModal = true;
      void this.webViewer.Core.documentViewer.setWatermark((_this$watermarkSettin = this.watermarkSettings) !== null && _this$watermarkSettin !== void 0 ? _this$watermarkSettin : {});
    }
  }, {
    key: "savePendingChanges",
    value: function () {
      var _savePendingChanges = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this$fieldEditTracke;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!this.fieldEditTracker) {
                _context21.next = 5;
                break;
              }
              _context21.next = 3;
              return (_this$fieldEditTracke = this.fieldEditTracker) === null || _this$fieldEditTracke === void 0 ? void 0 : _this$fieldEditTracke.flush();
            case 3:
              this.fieldEditTracker.dispose();
              this.fieldEditTracker = undefined;
            case 5:
              if (!this.annotationEditor) {
                _context21.next = 9;
                break;
              }
              _context21.next = 8;
              return this.annotationEditor.safeForDocumentUnload();
            case 8:
              this.annotationEditor = undefined;
            case 9:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function savePendingChanges() {
        return _savePendingChanges.apply(this, arguments);
      }
      return savePendingChanges;
    }()
  }, {
    key: "setOnTriggeredHandler",
    value: function setOnTriggeredHandler() {
      var _ref3 = this.webViewer,
        Core = _ref3.Core;
      var onTriggered = Core.Actions.GoTo.prototype.onTriggered;
      Core.Actions.GoTo.prototype.onTriggered = function (owner, event, documentViewer) {
        if (owner === Core.documentViewer.getDocument() && event.name === 'Open') {
          return;
        }
        onTriggered.apply(this, [owner, event, documentViewer]);
      };
    }
  }, {
    key: "getShadowRootNode",
    value: function getShadowRootNode() {
      return this.shadowRoot;
    }
  }], [{
    key: "generateRandomSocketClientId",
    value: function generateRandomSocketClientId() {
      return 'dms-socket-client-' + Math.random().toString().slice(2);
    }
  }, {
    key: "is",
    get: function get() {
      return 'dms-viewer';
    }
  }, {
    key: "styles",
    get: function get() {
      return styles;
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        document: {
          type: Object,
          reflect: true
        },
        documentUrl: {
          type: Object,
          reflect: true
        },
        container: {
          type: Object,
          reflect: true
        },
        hasPreviousDocument: {
          type: Boolean,
          reflect: true
        },
        hasNextDocument: {
          type: Boolean,
          reflect: true
        },
        userDisplayAs: {
          type: String,
          reflect: true
        },
        userContactId: {
          type: String,
          reflect: true
        },
        options: {
          type: Object,
          reflect: true
        },
        pageDataURL: {
          type: String,
          reflect: true
        },
        pdfDataURL: {
          type: String,
          reflect: true
        },
        loadSavedAnnotations: {
          type: Boolean,
          reflect: true
        },
        subscribeForNotifications: {
          type: Boolean,
          reflect: true
        },
        editAnnotations: {
          type: Boolean,
          reflect: true
        },
        showPrintButton: {
          type: Boolean,
          attribute: false
        },
        showWatermarkModal: {
          type: Boolean,
          attribute: false
        },
        watermarkSettings: {
          type: Object,
          attribute: false
        },
        showDownloadModal: {
          type: Boolean,
          attribute: true
        },
        documentIsLoading: {
          type: Boolean,
          attribute: false
        },
        hideDocumentPreview: {
          type: Boolean,
          attribute: true
        },
        documentIsDownloading: {
          type: Boolean,
          attribute: false
        },
        currentDocument: {
          type: Object,
          attribute: false
        },
        bmCoreFileViewerOptions: {
          type: Object,
          attribute: false
        },
        toolbarActions: {
          type: Object,
          attribute: true
        },
        customSelectMultiple: {
          type: Number,
          attribute: false
        },
        pageNo: {
          type: Number,
          attribute: false
        },
        finishScanClicked: {
          type: Boolean,
          attribute: false
        },
        fetchLatestPageData: {
          type: Boolean,
          attribute: false
        },
        documentSiblings: {
          type: Array
        }
      };
    }
  }]);
}(BlueElement);
export { DmsViewer as default };
export var register = function register() {
  return blueRegister(DmsViewer);
};
